import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as docketActions from '../../../redux/actions/docketActions';
import * as drupalDocketActions from '../../../redux/actions/drupalDocketActions';
import * as relatedTransactionActions from '../../../redux/actions/relatedTransactionActions';
import { hasValidClientCode } from '../../../redux/actions/clientCodeAction';
import AllPartsPrintPreview from '../docket/popups/AllPartsPrintPreview';
import EmailCombinedPdfPopup from '../docket/popups/EmailCombinedPdfPopup';
import DownloadZipAllPdfsRangePopup from '../docket/popups/DownloadZipAllPdfsRangePopup';
import DownloadCombineAllPdfInRangePopup from '../docket/popups/DownloadCombineAllPdfInRangePopup';
import DownloadZipWithSubpartsPopup from '../docket/popups/DownloadZipWithSubpartsPopup';
import PrintAllPdfInRangePopup from '../docket/popups/PrintAllPdfInRangePopup';
import EmailPartPopup from '../docket/popups/EmailPartPopup';
import EmailPartModal from '../docket/popups/EmailPartModal/EmailPartModal';
import EmailAllPartsZipPopup from '../docket/popups/EmailAllPartsZipPopup';

import RelatedTransaction from './RelatedTransaction';

const type = 'related_transactions';
const noDataFoundMessage = 'No Transactions found.';

const initState = {
  docNumFrom: null,
  docNumTo: null,
  startDate: null,
  endDate: null,
  pacerSearch: {
    startDate: null,
    endDate: null,
    doc_from: null,
    doc_to: null,
  },
  doc_range: '',
  doc_range_error: '',
  keyword: '',
  sort_field: 'date_event_filed',
  sort_direction: 'desc',
  ir_search_page_size: window.Drupal.settings.ir_search_page_size || 50,
};

export class RelatedTransactionContainer extends Component {
  constructor(props) {
    super();
    this.props = props;
    this.state = {
      ...initState,
      visibleDocketRow: '',
      selectedPageNum: 1,
      selectedDocketDetailNum: null,
      showEmailPopup: false,
      showEmailNotification: false,
      showPubliclinkPopup: false,
      showPacerFilterSection: this.props.purchase_right_away,
    };
    this.togglePacerFilterSection = this.togglePacerFilterSection.bind(this);
    this.changePage = this.changePage.bind(this);
    this.getDocketDetails = this.getDocketDetails.bind(this);
  }
  componentDidMount() {
    if (this.props.purchase_right_away) { this.purchaseData(); } else { this.getData(); }
  }

  onPopupClick = (params) => {
    this.props.dispatch(docketActions.togglePopup(params));
  }

  onClear = (e) => {
    this.setState(initState, () => {
      this.buyFilteredDockets(e);
    });
  }

  getData = (page_num = 0, sort_direction = this.state.sort_direction, sort_field = this.state.sort_field) => {
    this.setState({ showPacerFilterSection: false });
    this.props.dispatch(relatedTransactionActions.getParserSearchData({
      type,
      case_uuid: this.props.case_uuid,
      date_from: '_',
      date_to: '_',
      doc_from: '_',
      doc_to: '_',
      keyword: '_',
      sort_field,
      sort_direction,
      page_num,
    }, null));
  }
  getParserData = (values, page_num = 0, sort_direction = this.state.sort_direction, sort_field = this.state.sort_field) => {
    const date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '_';
    const date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '_';
    const doc_from = values.doc_from ? values.doc_from : '_';
    const doc_to = values.doc_to ? values.doc_to : '_';
    const keyword = values.keyword ? values.keyword : '_';

    this.props.dispatch(relatedTransactionActions.getParserSearchData({
      type,
      case_uuid: this.props.case_uuid,
      date_from,
      date_to,
      doc_from,
      doc_to,
      keyword,
      sort_field,
      sort_direction,
      page_num,
    }, null));
  }
  getDocketDetails = (seqNum, index = this.state.visibleDocketRow) => {
    this.setState({ selectedDocketDetailNum: seqNum, visibleDocketRow: `${index}` }, () => {
      const params = { case_uuid: this.props.case_uuid, seqNum };
      this.props.dispatch(drupalDocketActions.getDocketDetails(params));
    });
  }
  getCaseData = () => {
    this.props.dispatch(relatedTransactionActions.getCaseData({
      type,
      case_uuid: this.props.case_uuid,
    }, null));
  }

  purchaseData = (values) => {
    const keyword = values.keyword ? values.keyword : '';
    const doc_type = values.doc_type ? values.doc_type : '';
    const date_from = values.date_from ? values.date_from.format('YYYY-MM-DD') : '';
    const date_to = values.date_to ? values.date_to.format('YYYY-MM-DD') : '';
    const doc_from = values.doc_from ? values.doc_from : '';
    const doc_to = values.doc_to ? values.doc_to : '';
    let show_pending = values.pending ? values.pending : false;
    let show_terminated = values.terminated ? 1 : false;

    show_pending = show_pending ? '1' : '0';
    show_terminated = show_terminated ? '1' : '0';
    this.props.dispatch(relatedTransactionActions.purchaseRelatedTransactionsCaseData({
      type,
      case_uuid: this.props.case_uuid,
      keyword,
      date_from,
      date_to,
      doc_from,
      doc_to,
      show_pending,
      show_terminated,
      doc_type,
    })).then(this.getCaseData());
  }

  toggleEmailPopup() {
    this.setState({
      showEmailPopup: !this.state.showEmailPopup,
    });
  }

  closeEmailNotification() {
    this.setState({
      showEmailNotification: false,
    });
  }

  togglePublicLinkPopup() {
    this.setState({
      showPubliclinkPopup: !this.state.showPubliclinkPopup,
    });
  }
  togglePacerFilterSection() {
    this.setState({
      showPacerFilterSection: !this.state.showPacerFilterSection,
    });
  }
  changePage = (itemParams) => {
    this.setState({ selectedPageNum: itemParams.page_index });
    this.getData(itemParams.page_index);
  }
  reloadDetails = () => {
    this.getDocketDetails(this.props.selectedDocket.seqNum);
  }
  buyPdf = (docket_no, number, seqNum) => {
    if (this.props.dispatch(hasValidClientCode())) {
      const params = {
        case_uuid: this.props.case_uuid,
        docket_no,
        number,
        seqNum,
      };
      this.props.dispatch(docketActions.buyPdf(params))
        .then(this.reloadDetails);
    }
  }

  sortRelatedTransaction = (sort_field) => {
    const sort_direction = (this.state.sort_direction === 'asc')
      ? 'desc'
      : 'asc';

    this.setState({ sort_field, sort_direction });
    this.getData(0, sort_direction, sort_field);
  }

  changeFilter = (e, name) => {
    if (name === 'doc_range' && (!name.includes(',') || !name.includes('-'))) {
      this.setState({ [name]: e.target.value, doc_range_error: 'Please enter range in valid format!' });
    }
    this.setState({ [name]: e.target.value });
  }
  changeDate = (type, date) => {
    this.setState({ [type]: date });
  }
  handleDateChangeRaw = (type, e) => {
    const date = e.target.value;
    if (date.split('/').length !== 3) {
      return;
    }

    const sanitized = date.split('/').reduce((accum, next, idx) => {
      const n = (next.length < 2)
        ? `0${next}`
        : next;

      return (idx === 0)
        ? accum + n
        : `${accum}/${n}`;
    }, '');

    const d = moment(sanitized, 'MM-DD-YYYY');

    this.setState({ [type]: d });
  }

  handleDocRange = (range) => {
    const ranges = { doc_from: '_', doc_to: '_' };
    // check if its not empty
    if (range) {
      if (range.includes(',')) {
        const [doc_from, doc_to] = range.split(',');
        ranges.doc_from = doc_from;
        ranges.doc_to = doc_to;
      } else if (range.includes('-')) {
        const [doc_from, doc_to] = range.split('-');
        ranges.doc_from = doc_from;
        ranges.doc_to = doc_to;
      } else {
        ranges.doc_from = range;
      }
    }
    return ranges;
  }

  buyFilteredDockets = (values) => {
    this.setState({ showLoadingBar: true });
    const { date_from = '', date_to = '', doc_range = '', keyword = '' } = values;
    const doc_range_object = this.handleDocRange(doc_range);
    const params = {
      type,
      case_uuid: this.props.case_uuid,
      // is_ajax: 1,
      // receipt_only: 1,
      query: 'relatedTransaction_search',
      date_from: date_from ? date_from.format('MM-DD-YYYY') : '_',
      date_to: date_to ? date_to.format('MM-DD-YYYY') : '_',
      doc_from: doc_range_object.doc_from,
      doc_to: doc_range_object.doc_to,
      keyword: _.isEmpty(keyword) ? '_' : keyword,
      sort_field: this.state.sort_field,
      sort_direction: this.state.sort_direction,
      page_num: 0,
    };
    this.props.dispatch(relatedTransactionActions.getParserSearchData(params, null));
  }
  reloadDetails = () => {
    this.getDocketDetails(this.props.selectedDocket.seqNum);
  }

  popupForm = {
    EmailCombinedPdfPopup,
    AllPartsPrintPreview,
    DownloadZipAllPdfsRangePopup,
    DownloadZipWithSubpartsPopup,
    DownloadCombineAllPdfInRangePopup,
    PrintAllPdfInRangePopup,
    EmailPartPopup,
    EmailPartModal,
    EmailAllPartsZipPopup,
  }

  render() {
    const { entries = [] } = this.props.transactions;
    const { name } = this.props.popup;
    const RelatedTransactionPopup = this.props.popup.show && this.popupForm[name];

    const docketFilterProps = {
      keyword: this.state.keyword,
      doc_range: this.state.doc_range,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      onChange: this.changeFilter,
      changeDate: this.changeDate,
      onChangeDateRaw: this.handleDateChangeRaw,
      buyFilteredDockets: e => this.setState({ showLoadingBar: true }, this.buyFilteredDockets(e)),
      onClear: this.onClear,
    };
    const relatedTransactionPaginatorProps = {
      transactions: this.props.transactions,
      case_uuid: this.props.case_uuid,
      selectedPageNum: this.state.selectedPageNum,
      changePage: this.changePage,
      dispatch: this.props.dispatch,
    };
    const relatedTransactionEntriesProps = {
      entries,
      transactions: this.props.transactions,
      redactSeqNum: this.state.redactSeqNum,
      buyMissingDockets: this.buyMissingDockets,
      getDocketDetails: this.getDocketDetails,
      showRedactPopup: this.showRedactPopup,
      reloadDetails: this.reloadDetails,
      buyPdf: this.buyPdf,
      case_uuid: this.props.case_uuid,
      sortRelatedTransaction: this.sortRelatedTransaction,
      onPopupClick: this.onPopupClick,
      selectedDocketDetailNum: this.state.selectedDocketDetailNum,
    };
    const tableSortProps = {
      sort_direction: this.state.sort_direction,
      sort_field: this.state.sort_field,
    };

    return (
      <RelatedTransaction
        {...this.props}
        type={type}
        purchaseData={this.purchaseData}
        onSubmit={value => this.purchaseData(value)}
        resetParser={() => this.getData()}
        onSubmitParser={value => this.getParserData(value)}
        showPacerFilterSection={this.state.showPacerFilterSection}
        togglePacerFilterSection={this.togglePacerFilterSection}
        visibleDocketRow={this.state.visibleDocketRow}
        togglePublicLinkPopup={this.togglePublicLinkPopup}
        noDataFoundMessage={noDataFoundMessage}
        relatedTransactionPaginatorProps={relatedTransactionPaginatorProps}
        docketParts={this.props.docketParts}
        getDocketDetails={this.getDocketDetails}
        docketFilterProps={docketFilterProps}
        relatedTransactionEntriesProps={relatedTransactionEntriesProps}
        tableSortProps={tableSortProps}
        RelatedTransactionPopup={RelatedTransactionPopup}
        onPopupClick={this.onPopupClick}
        reloadDetails={this.reloadDetails}
      />
    );
  }
}

RelatedTransactionContainer.defaultProps = {
  purchase_right_away: false,
  error: null,
  receipt: null,
};

RelatedTransactionContainer.propTypes = {
  dispatch: PropTypes.func.isRequired,
  case_uuid: PropTypes.any.isRequired,
  purchase_right_away: PropTypes.bool,
  dataReady: PropTypes.bool.isRequired,
  docketParts: PropTypes.any.isRequired,
  selectedDocket: PropTypes.object.isRequired,
  transactions: PropTypes.any.isRequired,
  receipt: PropTypes.any,
  lastUpdated: PropTypes.any.isRequired,
  error: PropTypes.any,
};

const mapStateToProps = (state) => {
  const relatedTransactionReducer = state.get('relatedTransactions').toJS();
  const irSearch = state.get('irSearch').toJS();

  relatedTransactionReducer.data = [...relatedTransactionReducer.data, ...irSearch.data];
  const transactions = relatedTransactionReducer.data.reduce((accum, next) => {
    // eslint-disable-next-line
    accum[next[0]] = next[1];
    return accum;
  }, {});

  const { popup, docketParts, selectedDocket } = state.get('dockets').toJS();

  return {
    dataReady: relatedTransactionReducer.data_ready,
    transactions,
    popup,
    docketParts,
    selectedDocket,
    receipt: relatedTransactionReducer.receipt,
    lastUpdated: relatedTransactionReducer.lastUpdated,
    error: relatedTransactionReducer.error,
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(RelatedTransactionContainer);



// WEBPACK FOOTER //
// ./src/components/case/related_transaction/RelatedTransactionContainer.js